/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
export var halfPI = Math.PI / 2;
export var PiDiv180 = Math.PI / 180;
export function degToRad(deg) {
    return deg * PiDiv180; // deg * Math.PI / 180
}
export function radToDeg(rad) {
    return rad / PiDiv180; // rad * 180 / Math.PI
}
export function isPowerOfTwo(x) {
    return (x !== 0) && (x & (x - 1)) === 0;
}
/** return the value that has the largest absolute value */
export function absMax() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    var max = 0;
    var absMax = 0;
    for (var i = 0, il = values.length; i < il; ++i) {
        var value = values[i];
        var abs = Math.abs(value);
        if (abs > absMax) {
            max = value;
            absMax = abs;
        }
    }
    return max;
}
/** Length of an arc with angle in radians */
export function arcLength(angle, radius) {
    return angle * radius;
}
//# sourceMappingURL=misc.js.map